
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28605',
  depVersions: {
  "payments-ui-app": "static-1.28605",
  "bend-plugin-arboretum": "static-1.1962",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.505",
  "crm_data": "static-4.93093",
  "data-fetching-client": "static-1.10068",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8667",
  "foundations-components-legacy": "static-1.1692",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6010",
  "hs-test-utils": "static-1.8459",
  "hub-http": "static-1.6630",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11912",
  "I18n": "static-7.1694",
  "jasmine-runner": "static-1.6871",
  "quartz": "static-1.7595",
  "raven": "static-3.5925",
  "react-dlb": "static-1.92",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.119",
  "react-utils": "static-2.5628",
  "reselect": "static-3.15",
  "stripe-js": "static-1.118",
  "ui-components-test-utils": "static-1.6049",
  "UIComponents": "static-3.8858",
  "usage-tracker-public": "static-1.7546",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38002",
  "payments-checkout-lib": "static-1.528",
  "cssUtils": "static-1.1043",
  "customer-data-objects": "static-1.8114",
  "FireAlarmUi": "static-1.4807",
  "foundations-assets": "static-1.5306",
  "foundations-theming": "static-1.4903",
  "graphql": "static-1.92",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12219",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3307",
  "property-translator": "static-1.5800",
  "quartz-config": "static-1.1373",
  "quartz-core": "static-1.6814",
  "quartz-i18n": "static-1.1270",
  "quartz-routing": "static-1.1025",
  "quartz-tracking": "static-1.974",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17154",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "ReduxMessenger": "static-2.10792",
  "rpc-client-utils": "static-1.5090",
  "sanitize-text": "static-1.8577",
  "SharedI18nStrings": "static-1.186",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.513",
  "superstore": "static-1.5179",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11567",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7585",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3872",
  "quartz-webpack": "static-1.3819",
  "bend-plugin-quartz-routing": "static-1.673",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22647",
  "customer-data-email": "static-1.18589",
  "customer-data-ui-utilities": "static-1.10254",
  "dispatcher": "static-1.146",
  "frontend-preferences-client": "static-1.8339",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8183",
  "quick-fetch": "static-1.4196",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4936",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2619",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9846",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.92",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2964",
  "ui-fonts": "static-1.1174",
  "HeadJS": "static-2.813",
  "hs-test-utils-bend-plugin": "static-1.3570",
  "msw": "static-1.102",
  "msw-config": "static-1.21",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.366",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4729",
  "foundations-components-test-utils": "static-1.6150",
  "ui-addon-draggable": "static-3.5168",
  "commerce-billing-lib": "static-1.20443",
  "commerce-shared-components-lib": "static-1.19485",
  "commerce-tools-ui-lib": "static-1.11238",
  "crm-message-bus": "static-1.43999",
  "customer-data-objects-ui-components": "static-1.13451",
  "customer-data-properties": "static-1.52898",
  "growth-payments-core": "static-1.26408",
  "ui-addon-iframeable": "static-1.9498",
  "usage-tracker": "static-1.7735",
  "usage-tracker-container": "static-1.7725",
  "sassPrefix": "static-1.309",
  "inbound-db-properties-service-client": "static-1.4113",
  "foundations-theming-base": "static-1.3888",
  "bend-plugin-foundations-theming": "static-1.3386",
  "stylex": "static-1.45",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "hub-http-janus": "static-1.898",
  "hubspotter-http": "static-1.4933",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1270",
  "quartz-head": "static-1.1260",
  "quartz-test": "static-1.1270",
  "trellis-components": "static-1.2983",
  "usage-tracker-session-replay": "static-1.5421",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "immer": "static-1.104",
  "bend-plugin-chirp-manifest": "static-1.500",
  "chirp-fetch": "static-1.2322",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4894",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.121",
  "FormUrlGenerator": "static-2.5135",
  "sequences-lib": "static-1.8692",
  "apollo-link-hub-http": "static-2.5021",
  "FileManagerCore": "static-1.40251",
  "FileManagerLib": "static-1.40392",
  "hubspot-apollo-client": "static-1.5298",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.678",
  "timezone-utils": "static-2.5652",
  "ui-gdpr-components": "static-1.10650",
  "react-dnd-compat": "static-1.5031",
  "stylex-utils": "static-1.162",
  "trellis-theming": "static-1.1405",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2905",
  "hs-resources": "static-1.618",
  "pulse": "static-1.1061",
  "utility-belt": "static-1.2956",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1967",
  "customer-data-associations": "static-1.7752",
  "customer-data-property-utils": "static-1.8466",
  "customer-data-tracking": "static-1.7293",
  "framework-data-schema-resolvers": "static-1.7313",
  "framework-data-table": "static-2.12757",
  "object-builder-ui-client": "static-1.49936",
  "payments-enrollment-embed-lib": "static-1.24109",
  "stripe-embedded-components": "static-1.8163",
  "ui-addon-opt": "static-4.8804",
  "ai-components-ui-library": "static-1.9934",
  "customer-data-rte": "static-1.33817",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24752",
  "growth-onboarding-confetti": "static-1.3484",
  "growth-onboarding-empty-states": "static-1.6454",
  "hubspot-prosemirror": "static-1.19188",
  "InboxConnectUtils": "static-4.15757",
  "payment-link-components": "static-1.24353",
  "payments-post-enroll-local-storage-lib": "static-1.5524",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39091",
  "react-colorpicker": "static-2.10634",
  "ui-addon-upgrades": "static-9.18512",
  "ui-addon-video-player": "static-1.9057",
  "user-context": "static-1.5479",
  "restore-request-side-panel-lib": "static-1.1928",
  "atom": "static-1.5498",
  "reference-resolvers": "static-1.8598",
  "calling-global-api": "static-1.66034",
  "calling-internal-common": "static-1.31745",
  "calling-lifecycle-internal": "static-1.67416",
  "calling-lifecycle-messages": "static-1.59709",
  "commerce-products-lib": "static-1.10776",
  "conditional-properties-service-client": "static-1.4086",
  "crm-index-visualization-core": "static-1.4684",
  "crm-links": "static-1.6726",
  "crm-pipelines-api-client-types": "static-1.4417",
  "customer-data-properties-shared-msw-handlers": "static-1.10144",
  "external-options-client-types": "static-1.4415",
  "formula-editor": "static-1.14941",
  "google-libphonenumber": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3744",
  "inbounddb-objects-service-types": "static-1.4496",
  "meetings-icalendar-utils-lib": "static-1.1058",
  "multi-currency-client-types": "static-1.3982",
  "pipeline-validation-client-types": "static-1.4254",
  "property-value-citations": "static-1.3512",
  "reference-resolvers-lite": "static-1.8527",
  "smart-data-capture-core": "static-1.365",
  "smart-property-lib": "static-1.8533",
  "tiered-pricing": "static-1.2152",
  "topics-actions-lib": "static-1.596",
  "trial-components-library": "static-1.14296",
  "ui-addon-form-validation": "static-1.11340",
  "laboratory-lib": "static-3.7571",
  "onboarding-scopes": "static-1.6873",
  "seat-types-lib": "static-1.951",
  "magpie-lib": "static-1.5857",
  "navigation-messaging": "static-1.8396",
  "ts-schema": "static-1.4366",
  "hub-http-shared-msw-handlers": "static-1.10817",
  "hubspotter-http-shared-msw-handlers": "static-1.10815",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8549",
  "breeze-artifacts-sdk": "static-1.699",
  "copilot-toolkit": "static-1.12056",
  "audio-components": "static-1.6497",
  "ContentUtils": "static-1.69352",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29983",
  "FileManagerImages": "static-1.37903",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4562",
  "ui-universal-auth": "static-1.9632",
  "urlinator": "static-1.4937",
  "video-components": "static-1.14343",
  "video-data-lib": "static-1.35999",
  "video-embed": "static-1.36833",
  "hubspot-apollo-cache": "static-1.757",
  "event-emitter": "static-1.1380",
  "framework-builder-read-service-client": "static-1.4293",
  "fdsr-migration-layer": "static-1.432",
  "bend-plugin-pulse": "static-1.564",
  "fast-json-patch": "static-1.73",
  "framework-data-schema-quick-fetch": "static-1.7218",
  "persist-promise": "static-1.4124",
  "customer-data-reference-ui-components": "static-1.13588",
  "tasks-actions-lib": "static-1.343",
  "reporting-data": "static-1.69201",
  "purchase-motions-components": "static-1.6567",
  "growth-onboarding-feedback-components": "static-1.7003",
  "growth-onboarding-reliability": "static-1.5503",
  "marketplace-ui-apps-core": "static-1.19497",
  "onboarding-tours": "static-1.17311",
  "stripe-connect-js": "static-1.81",
  "chatspot-core": "static-1.23543",
  "content-assistance-lib": "static-1.8349",
  "draft-content-plugins": "static-1.29075",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22279",
  "rich-text-lib": "static-1.20477",
  "breeze-engine-lib": "static-1.2019",
  "poll-commands": "static-1.3895",
  "video-components-external": "static-1.12341",
  "trellis-story-utils": "static-1.4923",
  "ui-addon-react-router-dom": "static-1.9950",
  "content-media-capture": "static-1.5688",
  "knowledge-content-types": "static-1.8705",
  "ui-addon-emoji-picker": "static-1.10287",
  "ui-business-units-lib": "static-1.9516",
  "ui-shepherd-react": "static-3.10695",
  "hub-http-contrib": "static-1.3449",
  "ui-addon-sales-email": "static-1.5623",
  "commerce-tours-lib": "static-1.6788",
  "getting-started-shared-tasks": "static-1.19473",
  "sales-checkout-service-client": "static-1.3950",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18591",
  "onboarding-tours-utils": "static-1.1378",
  "calling-error-reporting": "static-1.31752",
  "shared-worker-versioning": "static-1.11461",
  "calling-usage-tracker": "static-1.6955",
  "voice-sms-access-library": "static-1.2330",
  "conversations-skeleton-state": "static-1.7602",
  "commerce-permissions": "static-1.1200",
  "products-iframe-lib": "static-1.8813",
  "products-ui-components-shared-msw-handlers": "static-1.11199",
  "crm-index-associations-lib": "static-1.6869",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10900",
  "sales-views-client-types": "static-1.4679",
  "location-customization-utils-lib": "static-1.10329",
  "bark-lib": "static-1.16952",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6309",
  "react-codemirror": "static-1.11061",
  "data-agent-kit": "static-1.818",
  "data-token-picker": "static-1.17049",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4175",
  "policy-lib": "static-1.7227",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10963",
  "embedded-academy-lib": "static-1.15861",
  "hubs-service-types": "static-1.1686",
  "navigation-components": "static-1.19069",
  "nudge-client-utils": "static-1.3330",
  "purchase-motions-api": "static-1.6570",
  "signup-constants": "static-1.19851",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5317",
  "reactive-lib": "static-1.1144",
  "simple-logging-lib": "static-1.3472",
  "cms-field-types": "static-1.5233",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17313",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1428",
  "social-insights-client-types": "static-1.22848",
  "outpost": "static-1.4554",
  "reporting-client-types": "static-1.2785",
  "signup-ui-url-generator": "static-2.8480",
  "developer-experience-shared-components": "static-1.10959",
  "immutable-less": "static-1.5071",
  "marketplace-ui-client-types": "static-1.18372",
  "marketplace-ui-common": "static-1.20965",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4337",
  "growth-data-modal": "static-1.6058",
  "growth-onboarding-next-action-utils": "static-1.2897",
  "onboarding-tours-client": "static-1.5526",
  "ui-shepherd-tracker": "static-1.8076",
  "ui-coaching-tips": "static-1.29515",
  "breeze-engine-chat-components": "static-1.997",
  "breeze-engine-core": "static-1.1297",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "content-media-composition-data-lib": "static-1.13492",
  "content-media-compositions": "static-2.17499",
  "media-bridge-lib": "static-1.19564",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4847",
  "calling-orchestration-schema": "static-1.37107",
  "crm-record-cards-service-types": "static-1.3834",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16578",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15321",
  "nest": "static-1.656",
  "nudge-custom-function-registry": "static-1.3087",
  "nudge-renderer-utils": "static-1.3406",
  "whisper-core-api": "static-1.7545",
  "flux-actions": "static-1.379",
  "integrations-error-boundary-lib": "static-1.14728",
  "integrations-tracking-lib": "static-1.6032",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1146",
  "apps-service-types": "static-1.4068",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8502",
  "nav-meta": "static-1.30706",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1443",
  "onboarding-data-sync-lib": "static-1.2759",
  "growth-onboarding-next-action-components": "static-1.2925",
  "user-context-client": "static-1.4930",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4114",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4814",
  "trellis-ecosystem": "static-1.7777",
  "wootric-nps": "static-1.7267",
  "universal-page-editor-lib": "static-1.3430",
  "adobe-sign-auth-lib": "static-1.675",
  "ads-unified-auth-lib": "static-1.1778",
  "custom-vendor-connection-lib": "static-1.196",
  "google-sheets-integration-lib": "static-1.1241",
  "microsoft-drive-auth-lib": "static-1.402",
  "surveymonkey-integration-lib": "static-1.770",
  "slack-ui-library": "static-1.10818",
  "settings-ui-lib": "static-1.12951",
  "simple-data-table": "static-1.3740",
  "meetings-connect-utils-lib": "static-1.8037"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28605",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1962",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.505",
  "crm_data": "/crm_data/static-4.93093",
  "data-fetching-client": "/data-fetching-client/static-1.10068",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8667",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1692",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6010",
  "hs-test-utils": "/hs-test-utils/static-1.8459",
  "hub-http": "/hub-http/static-1.6630",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11912",
  "I18n": "/I18n/static-7.1694",
  "jasmine-runner": "/jasmine-runner/static-1.6871",
  "quartz": "/quartz/static-1.7595",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.119",
  "react-utils": "/react-utils/static-2.5628",
  "reselect": "/reselect/static-3.15",
  "stripe-js": "/stripe-js/static-1.118",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6049",
  "UIComponents": "/UIComponents/static-3.8858",
  "usage-tracker-public": "/usage-tracker-public/static-1.7546",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38002",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.528",
  "cssUtils": "/cssUtils/static-1.1043",
  "customer-data-objects": "/customer-data-objects/static-1.8114",
  "FireAlarmUi": "/FireAlarmUi/static-1.4807",
  "foundations-assets": "/foundations-assets/static-1.5306",
  "foundations-theming": "/foundations-theming/static-1.4903",
  "graphql": "/graphql/static-1.92",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12219",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3307",
  "property-translator": "/property-translator/static-1.5800",
  "quartz-config": "/quartz-config/static-1.1373",
  "quartz-core": "/quartz-core/static-1.6814",
  "quartz-i18n": "/quartz-i18n/static-1.1270",
  "quartz-routing": "/quartz-routing/static-1.1025",
  "quartz-tracking": "/quartz-tracking/static-1.974",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17154",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10792",
  "rpc-client-utils": "/rpc-client-utils/static-1.5090",
  "sanitize-text": "/sanitize-text/static-1.8577",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "superstore": "/superstore/static-1.5179",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11567",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7585",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3872",
  "quartz-webpack": "/quartz-webpack/static-1.3819",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.673",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22647",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10254",
  "dispatcher": "/dispatcher/static-1.146",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8339",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8183",
  "quick-fetch": "/quick-fetch/static-1.4196",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4936",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2619",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9846",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.92",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2964",
  "ui-fonts": "/ui-fonts/static-1.1174",
  "HeadJS": "/HeadJS/static-2.813",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3570",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.21",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.366",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4729",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6150",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5168",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20443",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19485",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11238",
  "crm-message-bus": "/crm-message-bus/static-1.43999",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13451",
  "customer-data-properties": "/customer-data-properties/static-1.52898",
  "growth-payments-core": "/growth-payments-core/static-1.26408",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9498",
  "usage-tracker": "/usage-tracker/static-1.7735",
  "usage-tracker-container": "/usage-tracker-container/static-1.7725",
  "sassPrefix": "/sassPrefix/static-1.309",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4113",
  "foundations-theming-base": "/foundations-theming-base/static-1.3888",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3386",
  "stylex": "/stylex/static-1.45",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hubspotter-http": "/hubspotter-http/static-1.4933",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1270",
  "quartz-head": "/quartz-head/static-1.1260",
  "quartz-test": "/quartz-test/static-1.1270",
  "trellis-components": "/trellis-components/static-1.2983",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5421",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "immer": "/immer/static-1.104",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.500",
  "chirp-fetch": "/chirp-fetch/static-1.2322",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4894",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.121",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5135",
  "sequences-lib": "/sequences-lib/static-1.8692",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5021",
  "FileManagerCore": "/FileManagerCore/static-1.40251",
  "FileManagerLib": "/FileManagerLib/static-1.40392",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5298",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.678",
  "timezone-utils": "/timezone-utils/static-2.5652",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10650",
  "react-dnd-compat": "/react-dnd-compat/static-1.5031",
  "stylex-utils": "/stylex-utils/static-1.162",
  "trellis-theming": "/trellis-theming/static-1.1405",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2905",
  "hs-resources": "/hs-resources/static-1.618",
  "pulse": "/pulse/static-1.1061",
  "utility-belt": "/utility-belt/static-1.2956",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1967",
  "customer-data-associations": "/customer-data-associations/static-1.7752",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8466",
  "customer-data-tracking": "/customer-data-tracking/static-1.7293",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7313",
  "framework-data-table": "/framework-data-table/static-2.12757",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49936",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24109",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8163",
  "ui-addon-opt": "/ui-addon-opt/static-4.8804",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9934",
  "customer-data-rte": "/customer-data-rte/static-1.33817",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24752",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3484",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6454",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19188",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15757",
  "payment-link-components": "/payment-link-components/static-1.24353",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5524",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39091",
  "react-colorpicker": "/react-colorpicker/static-2.10634",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18512",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "user-context": "/user-context/static-1.5479",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1928",
  "atom": "/atom/static-1.5498",
  "reference-resolvers": "/reference-resolvers/static-1.8598",
  "calling-global-api": "/calling-global-api/static-1.66034",
  "calling-internal-common": "/calling-internal-common/static-1.31745",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67416",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59709",
  "commerce-products-lib": "/commerce-products-lib/static-1.10776",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4684",
  "crm-links": "/crm-links/static-1.6726",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10144",
  "external-options-client-types": "/external-options-client-types/static-1.4415",
  "formula-editor": "/formula-editor/static-1.14941",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4496",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1058",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3982",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4254",
  "property-value-citations": "/property-value-citations/static-1.3512",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8527",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.365",
  "smart-property-lib": "/smart-property-lib/static-1.8533",
  "tiered-pricing": "/tiered-pricing/static-1.2152",
  "topics-actions-lib": "/topics-actions-lib/static-1.596",
  "trial-components-library": "/trial-components-library/static-1.14296",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11340",
  "laboratory-lib": "/laboratory-lib/static-3.7571",
  "onboarding-scopes": "/onboarding-scopes/static-1.6873",
  "seat-types-lib": "/seat-types-lib/static-1.951",
  "magpie-lib": "/magpie-lib/static-1.5857",
  "navigation-messaging": "/navigation-messaging/static-1.8396",
  "ts-schema": "/ts-schema/static-1.4366",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10817",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10815",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8549",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.699",
  "copilot-toolkit": "/copilot-toolkit/static-1.12056",
  "audio-components": "/audio-components/static-1.6497",
  "ContentUtils": "/ContentUtils/static-1.69352",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29983",
  "FileManagerImages": "/FileManagerImages/static-1.37903",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4562",
  "ui-universal-auth": "/ui-universal-auth/static-1.9632",
  "urlinator": "/urlinator/static-1.4937",
  "video-components": "/video-components/static-1.14343",
  "video-data-lib": "/video-data-lib/static-1.35999",
  "video-embed": "/video-embed/static-1.36833",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.757",
  "event-emitter": "/event-emitter/static-1.1380",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4293",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.432",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.564",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7218",
  "persist-promise": "/persist-promise/static-1.4124",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13588",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.343",
  "reporting-data": "/reporting-data/static-1.69201",
  "purchase-motions-components": "/purchase-motions-components/static-1.6567",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7003",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5503",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19497",
  "onboarding-tours": "/onboarding-tours/static-1.17311",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "chatspot-core": "/chatspot-core/static-1.23543",
  "content-assistance-lib": "/content-assistance-lib/static-1.8349",
  "draft-content-plugins": "/draft-content-plugins/static-1.29075",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22279",
  "rich-text-lib": "/rich-text-lib/static-1.20477",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2019",
  "poll-commands": "/poll-commands/static-1.3895",
  "video-components-external": "/video-components-external/static-1.12341",
  "trellis-story-utils": "/trellis-story-utils/static-1.4923",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9950",
  "content-media-capture": "/content-media-capture/static-1.5688",
  "knowledge-content-types": "/knowledge-content-types/static-1.8705",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10287",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9516",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10695",
  "hub-http-contrib": "/hub-http-contrib/static-1.3449",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5623",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6788",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19473",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3950",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18591",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1378",
  "calling-error-reporting": "/calling-error-reporting/static-1.31752",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11461",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6955",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2330",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "commerce-permissions": "/commerce-permissions/static-1.1200",
  "products-iframe-lib": "/products-iframe-lib/static-1.8813",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11199",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6869",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10900",
  "sales-views-client-types": "/sales-views-client-types/static-1.4679",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10329",
  "bark-lib": "/bark-lib/static-1.16952",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6309",
  "react-codemirror": "/react-codemirror/static-1.11061",
  "data-agent-kit": "/data-agent-kit/static-1.818",
  "data-token-picker": "/data-token-picker/static-1.17049",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4175",
  "policy-lib": "/policy-lib/static-1.7227",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10963",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15861",
  "hubs-service-types": "/hubs-service-types/static-1.1686",
  "navigation-components": "/navigation-components/static-1.19069",
  "nudge-client-utils": "/nudge-client-utils/static-1.3330",
  "purchase-motions-api": "/purchase-motions-api/static-1.6570",
  "signup-constants": "/signup-constants/static-1.19851",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5317",
  "reactive-lib": "/reactive-lib/static-1.1144",
  "simple-logging-lib": "/simple-logging-lib/static-1.3472",
  "cms-field-types": "/cms-field-types/static-1.5233",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17313",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1428",
  "social-insights-client-types": "/social-insights-client-types/static-1.22848",
  "outpost": "/outpost/static-1.4554",
  "reporting-client-types": "/reporting-client-types/static-1.2785",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8480",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10959",
  "immutable-less": "/immutable-less/static-1.5071",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18372",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20965",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4337",
  "growth-data-modal": "/growth-data-modal/static-1.6058",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2897",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5526",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8076",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29515",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.997",
  "breeze-engine-core": "/breeze-engine-core/static-1.1297",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13492",
  "content-media-compositions": "/content-media-compositions/static-2.17499",
  "media-bridge-lib": "/media-bridge-lib/static-1.19564",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4847",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37107",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16578",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15321",
  "nest": "/nest/static-1.656",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3087",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3406",
  "whisper-core-api": "/whisper-core-api/static-1.7545",
  "flux-actions": "/flux-actions/static-1.379",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14728",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6032",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1146",
  "apps-service-types": "/apps-service-types/static-1.4068",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8502",
  "nav-meta": "/nav-meta/static-1.30706",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1443",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2759",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2925",
  "user-context-client": "/user-context-client/static-1.4930",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4114",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4814",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7777",
  "wootric-nps": "/wootric-nps/static-1.7267",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3430",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.675",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1778",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.196",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1241",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.402",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.770",
  "slack-ui-library": "/slack-ui-library/static-1.10818",
  "settings-ui-lib": "/settings-ui-lib/static-1.12951",
  "simple-data-table": "/simple-data-table/static-1.3740",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8037"
}
};
